import axios from "axios";

const moduleProductInventory = {
  namespaced: true,
  state: {
    productList: [],
    createProductItem: null,
  },
  mutations: {
    setProductList(state, data) {
      state.productList = data;
    },
  },
  actions: {
    async fetchProductList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(`/api/stocks/${clinicUrl}/${branchUrl}`);
        const items = res.data.data.map(i => ({
          productId: i.product.id,
          productCode: i.product.no,
          productCatagory: i.product.category,
          productNameMain: i.product.description,
          productNameAdditional: i.product.description2,
          productStock: i.qtyAvailable,
          productUnit: i.product.baseUom,
          productPrice: i.avgCost,
          productStatus: i.product.status,
          productPurchaseUnit: i.product.purchaseUom,
          productSalesUnit: i.product.saleUom,
          productConversionUnitItems: i.product.productUomConversions,
        }));

        commit("setProductList", items);
        return items;
      } catch (err) {
        console.error("fetchProductList failed", err);
        throw err;
      }
    },
    createProductItem({ commit, getters }, payload) {
      return axios
        .post(
          `/api/master/products/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustProductItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    updateProductItem({ commit, getters }, payload) {
      return axios
        .put(
          `/api/master/products/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          payload.adjustProductItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
    deleteProductItem({ commit, getters }, payload) {
      return axios
        .delete(
          `/api/master/products/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {
    getProductList: state => {
      return state.productList;
    },
  },
};

export default moduleProductInventory;
